var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconesJobss03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 385.6 306.2",
    style: {
      enableBackground: "new 0 0 385.6 306.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2F99C8;}\r\n\t.st1{fill:#2F99C8;stroke:#2F99C8;stroke-width:3.0305;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.9,249.9c-13.9,16-27.6,31.8-41.3,47.6c-1.7,1.9-3.6,3.7-5.5,5.4c-4.8,4.3-10,4.7-14.5-0.1 c-4.5-4.7-3.8-9.9,0.5-14.6c8.1-8.9,16.7-17.4,24.4-26.6C49.8,252.8,56,243.1,63,234c3.3-4.3,3-7.8,0.5-12.4 c-20.4-37.8-40.7-75.8-53.8-117C2.9,83.3-2.7,61.6,1.4,38.8C5.1,18.1,17.2,4.7,35.2,1c19.1-3.9,37.7,3.7,48.7,21.4 c39.9,64.1,43.1,130.2,10.5,198.2c-3.8,7.9-0.3,19.4,8.1,25.7c6.9,5.2,15.1,4.4,22.4-2.9c10.5-10.6,20.7-21.5,31-32.3 c18.6-19.8,46-17.3,60.6,5.6c8.9,13.9,17.7,15.2,30,4.3c4.5-4,8.9-8.1,13.6-11.9c19.2-15.7,47.4-9.3,56.8,13.6 c4.5,11.1,11.3,15.5,22.9,14.9c11.2-0.6,22.4-0.1,33.6-0.1c6.9,0,12.2,2.6,12.3,10.1c0.1,7.5-5,10.4-12,10.5 c-13.5,0-27,0.4-40.5-0.1c-15.8-0.6-27.1-8.4-33.3-23.1c-6.8-15.9-17-18.5-29.9-7.4c-4.3,3.7-8.5,7.7-12.9,11.4 c-18.6,15.6-43.1,12-56.6-8.3c-10.8-16.1-19.5-16.7-32.5-2.5c-8.1,8.9-16.4,17.6-25,26.1C120.2,276.9,98,275.3,78.9,249.9z  M77.8,205.9c1.1-1.6,1.7-2.2,2-2.9C105,143.7,100.5,86.8,66,32.3c-6.2-9.8-17.5-13.9-27.6-11.4c-9.1,2.3-16.9,11.3-17.3,23.3 c-0.4,11.1,0.2,22.5,2.6,33.2c8.1,37,24.8,70.7,41.6,104.3C69.3,189.7,73.4,197.5,77.8,205.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconesJobss03);
export default __webpack_public_path__ + "static/media/IconesJobss03.8b29c7fe012a629b26e44fb6bfd5193f.svg";
export { ForwardRef as ReactComponent };